import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArcBox, ArcIconButton, ArcStack, ArcText } from '@src/core/ui';
import { rootLinks } from '@src/layouts/root-layout/config/nav-links';
import { countDronesNeedingOtaUpdate } from '@src/layouts/root-layout/utils/ota-badge';
import { SidebarProps } from './types';
import { useGetDronesQuery, useGetUserDataQuery, UserEntity } from '@src/core/features';
import { routesConfig } from '@src/core/routes';


const Sidebar: React.FC<SidebarProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data = {} as UserEntity } = useGetUserDataQuery();
  const { data: dronesResponse } = useGetDronesQuery();
  const fleetOtaBadgeCount = countDronesNeedingOtaUpdate(dronesResponse?.data);


  return (
    <ArcStack 
      p={2}
      pt={5}
      width={80} 
      spacing={1}
      top={0}
      position='fixed'
      minHeight='100vh'
      justifyContent='space-between' 
      bgcolor='background.paper'>
      <ArcStack spacing={1}>
        {rootLinks.map((link) => {
          const isPath = link.exact.some(path => {
            if (path.includes('/:id')) {
              const basePath = path.replace('/:id', '');
              return location.pathname.startsWith(basePath) && location.pathname !== basePath;
            }
            return path === location.pathname;
          });

          const navIcon = isPath ? link.activeIcon : link.icon;
          const navColor = isPath ? 'brand.main' : 'text.primary';

          const hasPermission = link.roles.includes(data.role);
          const showFleetOtaBadge = link.path === routesConfig.fleet && fleetOtaBadgeCount > 0;

          if (hasPermission) {
        
            return (
              <ArcIconButton 
                key={link.id}
                onClick={() => navigate(link.path)}
                sx={{ minWidth: 50 }}>
                <ArcStack minWidth={50} spacing='4px' alignItems='center'>
                  <ArcStack width={18} minWidth={18} position='relative'>
                    {navIcon}
                    {showFleetOtaBadge && (
                      <ArcBox
                        position='absolute'
                        top={-6}
                        right={-8}
                        width={16}
                        height={16}
                        borderRadius='50%'
                        bgcolor='error.main'
                        display='flex'
                        alignItems='center'
                        justifyContent='center'
                      >
                        <ArcText.caption
                          fontSize={10}
                          fontWeight={500}
                          lineHeight={1}
                          letterSpacing={0}
                          textTransform='uppercase'
                          color='common.white'
                        >
                          {fleetOtaBadgeCount}
                        </ArcText.caption>
                      </ArcBox>
                    )}
                  </ArcStack>
                  <ArcText.button fontSize={9} color={navColor}> 
                    {link.name} 
                  </ArcText.button>
                </ArcStack>
              </ArcIconButton>
            );
          }
          return null;
        })}
      </ArcStack>

    </ArcStack>
  );
};

export default Sidebar;